export default {
      id: "ind-clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ind-clock",
      toString: function () {
        return this.url;
      }
    }